export default "__VITE_ASSET__C0Fm2U1s__"